/**
 * @param {Query} query
 * @return {Query}
 */
export default function ConsoleLog(query) {
  console.info(query.result.content);

  return query;
}
